/* eslint-disable jsx-a11y/label-has-associated-control */
import { Content } from "@iventis/translations/content/typed-content";
import React, { FunctionComponent } from "react";
import { Header4 } from "@iventis/styles/src/components/texts";
import { TypographyColorsEnum } from "@iventis/styles/src/style.types";
import styled from "@emotion/styled";
import { UseIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type EnteredEmailProps = {
    emailEntered: boolean;
    emailInput: string;
    translate: UseIventisTranslate;
    setEmailEntered: (emailEntered: boolean) => void;
};

export const LoginEnteredEmail: FunctionComponent<EnteredEmailProps> = ({ emailEntered, setEmailEntered, emailInput, translate }) => (
    <Header4 color={TypographyColorsEnum.CORE}>
        {emailEntered && emailInput && emailInput.length ? (
            <div style={{ display: "flex", placeItems: "center" }}>
                <StyledFontAwesomeIcon onClick={() => setEmailEntered(false)} size="xs" icon={["fas", "arrow-left"]} />
                {emailInput}
            </div>
        ) : (
            <span>{translate(Content.login.headings.login)}</span>
        )}
    </Header4>
);

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
    cursor: pointer;
`;
